module.exports = __webpack_public_path__ + "images/ds-lda-instructor-randy-rosseel.webp";